import Component from '../core/Component'
import { CMS } from '../core/config'
import { queryAll } from '../utils/dom'

export default class PageHeaderTitle extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            items: []
        }
    }

    prepare() {
        if (CMS) {
            return
        }

        this.ref.items.forEach(item => {
            item.innerHTML = item.innerHTML
            .trim()
            .split(' ')
            .map(item => `<span class="a-Up">${item}</span>`)
            .join(' ')
        })

        this.items = queryAll('.a-Up', this.element)

        this.refresh()
    }

    refresh() {
        const items = this.items
            .map(element => ({
                element,
                top: element.getBoundingClientRect().top
            }))
            .map((item, index, list) => {
                if (index === 0) {
                    item.row = 1
                } else {
                    item.row = item.top === list[index - 1].top ? list[index - 1].row : list[index - 1].row + 1
                }
                return item
            })

        const rows = Math.max(...items.map(item => item.row))

        items.forEach(item => item.element.className = `a-Up a-Up--f${item.row} a-Up--b${rows - item.row + 1}`)
    }

}
